import { MenuItem } from '@/types';

export const menu: MenuItem[] = [
  {
    label: `Home`,
    path: `/`,
  },
  {
    label: `Company`,
    path: `/company`,
  },
  {
    label: `Contact`,
    path: `/contact`,
  },
  {
    label: `Services`,
    path: `/services`,
  },
  {
    label: `Blog`,
    path: `/blog`,
    external: true,
  },
  {
    label: `Login`,
    path: process.env.GATSBY_DASHBOARD_URL,
    external: true,
  },
  // {
  //   label: `Products`,
  //   path: `/products`,
  // },
  // {
  //   label: `Use Cases`,
  //   path: `/use-cases`,
  // },
  // {
  //   label: `Resources`,
  //   path: `/resources`,
  // },
  // {
  //   label: `Customers`,
  //   path: `/customers`,
  // },
];

export const links: MenuItem[] = [
  {
    label: `Home`,
    path: `/`,
  },
  {
    label: `Company`,
    path: `/company`,
  },
  {
    label: `Services`,
    path: `/services`,
  },
  {
    label: `Remove my site`,
    path: `/remove-my-website`,
  },
  {
    label: `Contact Us`,
    path: `/contact`,
  },
];

export const terms: MenuItem[] = [
  {
    label: `Privacy Policy`,
    path: `/privacy-policy`,
  },
  {
    label: `Terms & Conditions`,
    path: `/terms-and-conditions`,
  },
  // {
  //   label: `Copyright Policy`,
  //   path: `/copyright`,
  // },
  // {
  //   label: `Fees & Charges`,
  //   path: `/fees`,
  // },
];
